module.exports = __webpack_public_path__ + "static/media/SellerboxFuncIconParty.a76a448e.png";